
export const ValidateLeaseAdminFuncInput = (lease, _createErrorMessage) => {

  if (!lease) {
    _createErrorMessage("79");
    return false;
  }

  return true;
};
